// extracted by mini-css-extract-plugin
module.exports = {"layoutService":"layout-service-module--layoutService--293f0"};